import { get, post,postJson } from "@/api/axios";
import axios from "axios";
import { useInterceptorsResponsehandle } from "../errorHandle";
import { $yunqueAxios, $jdAxios } from "../yunQueAxios";

const $taobaoAxios = axios.create({
  baseURL: "/taobao-api",
});

const interceptorsResponsehandle = useInterceptorsResponsehandle($taobaoAxios);

interceptorsResponsehandle(
  (res) => {},
  (error) => {}
);
// 云雀地区数据
export const getYqArea = () => get(`/common/area`);

// 云雀平台店铺级联
export const getCrmData = () => get(`/common/getCrmData`);

// 获取平台新老客和金额信息
export const getPlatformNewOldCustomerAndAmount = (params) => get(`/bi-common/data-config`,params);

// 获取所有数据配置
export const getAllDataConfig = () => get(`/bi-common/all-data-config`);

// 获取人群画像分析记录
export const getPeoplePicRecord = (data) => postJson(`/bi-common/crowd-portrait/generate`, data);

// 导出人群画像分析记录
export const exportPeoplePicRecord = (accessKey,params) => get(`/bi-common/crowd-portrait/export/${accessKey}`,params);

// 淘宝分类列表
export const getTaobaocats = (token) =>
  $taobaoAxios.post(`/public/getTaobaocats`, null, {
    headers: {
      "yunque-token": token,
    },
  });

// 淘宝商品列表
export const getTaobaoItemList = (query, token) =>
  $taobaoAxios.post(`/public/getTaobaoItemList`, query, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 淘宝品牌列表
export const getTbBrandList = (query, token) =>
  $taobaoAxios.post(`/public/getBrandList`, query, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 抖音分类列表
export const getTaobaocatsDY = (token) =>
  $yunqueAxios.post(`/public/getTaobaocats`, null, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 抖音商品列表
export const getTaobaoItemListDY = (query, token) =>
  $yunqueAxios.post(`/public/getTaobaoItemList`, query, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 抖音品牌列表
export const getTaobaoItemSkuListDY = (query, token) =>
  $yunqueAxios.post(`/public/getTaobaoItemSkuList`, query, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 抖音类目列表
export const getSellercatsDY = (query, token) =>
  $yunqueAxios.post(`/public/getSellercats`, query, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 抖音获取商品信息
export const getPlatformTaobaoItemListDY = (query, token) =>
  $yunqueAxios.post(`/public/getPlatformTaobaoItemList`, query, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 抖音获取SKU商品信息
export const getSkuListDY = (query, token) =>
  $yunqueAxios.post(`/public/getSkuList`, query, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 更新
export const syncItemDY = (token) =>
  $yunqueAxios.post(`/public/syncItem`, null, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 京东-同步
export const synchroJdWare = (token) =>
  $jdAxios.post(`/popCommentWareAnalysis/synchroJdWare`, null, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 京东-获取店铺类目
export const getSellercatsJD = (token) =>
  $jdAxios.get(`/ware/category/all`, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 京东-获取店铺商品
export const getTaobaoItemListJD = (token) =>
  $jdAxios.post(`/ware/all`, null, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 京东-客户营销会员分群分页获取商家sku列表
export const getTaobaoItemListSkuJD = (query, token) =>
  $jdAxios.post(`/ware/sku/page`, query, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 京东-将已选spu或sku加入到分组
export const addToGroupJD = (query, token) =>
  $jdAxios.post(`/ware/addToGroup`, query, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 京东-获取商品分组列表
export const getGroupListJD = (query, token) =>
  $jdAxios.get(`/ware/getGroupList`, query, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 京东-删除商品分组
export const delSkuGroupJD = (query, venderId, token) =>
  $jdAxios.delete(`/ware/delSkuGroup/${query}?venderId=${venderId}`, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 京东-查询分组下所有商品
export const getSkuListByGroupJD = (query, venderId, token) =>
  $jdAxios.get(`/ware/getSkuListByGroup/${query}?venderId=${venderId}`, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 京东-导入SKU-手动输入
export const SKUinputTextJD = (query, token) =>
  $jdAxios.post(`/ware/importSku/inputText`, query, {
    headers: {
      "yunque-token": token,
      "Content-Type": "application/json",
    },
  });

// 京东-导入SKU-文件上传
export const importSkuFileJD = (p, q, token) =>
  $jdAxios.post(`/ware/importSku/file?venderId=${q}`, p, {
    headers: {
      "yunque-token": token,
      "Content-Type": "multipart/form-data",
    },
  });

  // 获取当前企业会员通会员卡店铺信息
  export const getHytScoreCardSeller = () => get('/common/getHytScoreCardSeller');

  // 获取当前企业会员体系
  export const getCompanyBrands = () => get('/common/getCompanyBrands');
